import { paragraphStyle, bottomMarginItemGlobal, fontSizeParagraph, lineHeightGlobal } from "../../utils/pdfConstants";

const KL_COLORS = {
  KL1: "#ba3b46",
  KL2: "#ba3b46",
  KL3: "#d0c407",
  KL4: "#04aa00",
  KL5: "#04aa00",
};

function kuntoTopMargin(label) {
  const charsPerLine = Math.floor(112 / 6.5); // 112pt available, bold Lato 11pt ≈ 6.5pt/char
  const lines = Math.ceil((label || "").length / charsPerLine);
  return lines >= 2 ? 9 : 4;
}

export function renderKuntoTable({ data, content }) {
  const { headerLabel = "", headerDescription = "", rows = [] } = data || {};

  const tableBody = [];

  const CELL = { font: "Lato", fontSize: fontSizeParagraph, margin: [4, 4, 4, 4], verticalAlignment: 'top' };

  // Header row
// Header row
tableBody.push([
  {
    ...CELL,
    text: "Kunto",
    bold: true,
    alignment: "center",
    border: [false, false, false, true],
    borderColor: ["", "", "", "#198754"]
  },
  {
    ...CELL,
    text: headerLabel ? `${headerLabel}:` : " ",
    bold: true,
    border: [false, false, false, true],
    borderColor: ["", "", "", "#198754"]
  },
  {
    ...CELL,
    text: headerDescription || " ",
    border: [false, false, false, true],
    borderColor: ["", "", "", "#198754"]
  },
]);

  // Data rows
  for (const row of rows) {
    const isNone = row.kunto === "-";
    const color = KL_COLORS[row.kunto] || "#333";
    tableBody.push([
      { ...CELL, text: isNone ? "" : (row.kunto || ""), bold: true, color, alignment: "center", border: [false, false, false, true], borderColor: ["", "", "", "#e5e7eb"] },
      { ...CELL, text: row.label ? `${row.label}:` : "", bold: true, border: [false, false, false, true], borderColor: ["", "", "", "#e5e7eb"] },
      { ...CELL, text: isNone ? "Ei ole." : (typeof row.description === "object" ? (row.description?.value || "") : (row.description || "")), lineHeight: lineHeightGlobal, border: [false, false, false, true], borderColor: ["", "", "", "#e5e7eb"] },
    ]);
  }

  if (tableBody.length === 0) return;

  content.push({
    table: {
      widths: [44, 210, "*"],
      body: tableBody,
    },
    layout: {
      hLineWidth: (i, node) => 1,
      vLineWidth: () => 0,
      hLineColor: (i, node) => {
        if (i === 1) return "#198754";
        return "#e5e7eb";
      },
      paddingLeft: () => 0,
      paddingRight: () => 0,
      paddingTop: () => 0,
      paddingBottom: () => 0,
    },
    margin: [0, 0, 0, bottomMarginItemGlobal],
    unbreakable: true,
  });
}
